import { application } from "./application"

import SearchController from "./search_controller"
import FlashController from "./flash_controller"
import ConfirmationController from "./confirmation_controller"
import AutofixPromptController from "./autofix_prompt_controller"
import LogViewerController from "./log_viewer_controller"

application.register("search", SearchController)
application.register("flash", FlashController)
application.register("confirmation", ConfirmationController)
application.register("autofix-prompt", AutofixPromptController)
application.register("log-viewer", LogViewerController)
